module.exports = __webpack_public_path__ + "static/UmangAgarwal-c7028972717699f539da28e8331a7ce2.jpg";